export const defaultPopupOptions = {
    offset: 5,
    anchor: 'left',
    className: '',
    permanent: false,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9wdXAuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsib2JqZWN0cy9wb3B1cC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjQSxNQUFNLENBQUMsTUFBTSxtQkFBbUIsR0FFNUI7SUFDSCxNQUFNLEVBQUUsQ0FBQztJQUNULE1BQU0sRUFBRSxNQUFNO0lBQ2QsU0FBUyxFQUFFLEVBQUU7SUFDYixTQUFTLEVBQUUsS0FBSztDQUNoQixDQUFBIn0=